// export const baseURL = "https://gfcb8ed8eb8355a-st94sy8hnd7n7e0g.adb.ap-mumbai-1.oraclecloudapps.com/ords/leadmerge";
export const baseURL = "https://g4771f79f8f4279-leadmerge.adb.ap-hyderabad-1.oraclecloudapps.com/ords/leadmerge";

// export const aiBaseUrl = "https://aibknd.leadmerge.com/"
// export const aiBaseUrl = "http://127.0.0.1:8001/" 
export const aiBaseUrl = "https://aiswan.betaphase.in/"


